var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrustum(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4816"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 739",
    d: "M8.7564 3.91677L4.21209 2.826L3.08325 5.60572L0.825562 11.4467L9.42213 14.4375L15.3847 9.65215L12.4613 2.12227L11.6509 1.70003L8.7564 3.91677Z",
    fill: "#00C2FF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 736",
    d: "M7.36701 0.75L4.7041 2.68525L8.87214 4.05752L11.535 1.80559L7.36701 0.75Z",
    fill: "#00C2FF",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 737",
    d: "M8.901 4.16308L9.7404 14.0153L15.3267 9.72253L12.1172 1.75",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 738",
    d: "M4.22652 2.91396L0.782104 11.4643L9.47998 14.4023",
    stroke: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrustum);
export default __webpack_public_path__ + "static/media/frustum.0b46c3d643c5c2d3d04022f3ec612998.svg";
export { ForwardRef as ReactComponent };